import type { IBlotterPreferenceState } from 'components/shared/Blotter/Grid/blotter.model';
import type { IBlotterItem } from 'models/IBlotterItem';
import type { IBlotterColumnDefinition } from 'state/blotters/common/blotter.model';
import type { AppState } from 'state/state.model';

import type {
  ISecondaryMarketTradeBlotterFilters,
  SecondaryMarketTradeBlotterState,
} from './secondaryMarketTradeBlotter.model';

export function getColumnDefinition(state: SecondaryMarketTradeBlotterState): IBlotterColumnDefinition<IBlotterItem>[] {
  return state.columnDefinition;
}

export function getFilters(state: SecondaryMarketTradeBlotterState): ISecondaryMarketTradeBlotterFilters {
  return {
    quickSearchTerm: state.quickSearchTerm,
    dateFilter: state.dateFilter,
    activityFilter: state.activityFilter,
    advancedFilters: state.advancedFilters,
    currencyFilter: state.currencyFilter,
    platformFilter: state.platformFilter,
  };
}

export function getPaginationInfo(state: SecondaryMarketTradeBlotterState) {
  return {
    page: state.page,
    itemsPerPage: state.blotterPreferenceState.pageSizeState,
    totalItems: state.totalItems,
    totalPages: state.totalPages,
  };
}

const emptyItems: readonly [] = [];
export function getPageItems(state: SecondaryMarketTradeBlotterState) {
  const items = state.items;
  return Array.isArray(items) && items.length > 0 ? items : emptyItems;
}

export interface ITradeRequest extends ISecondaryMarketTradeBlotterFilters {
  page: number;
  itemsPerPage: number;
  sort: string;
  sortDir: string;
}
export function getTradeRequest(state: SecondaryMarketTradeBlotterState): ITradeRequest {
  return {
    page: state.page,
    itemsPerPage: state.blotterPreferenceState.pageSizeState || 25,
    // @ts-ignore: TS2322
    sort: state.sort,
    sortDir: state.sortDir,
    activityFilter: state.activityFilter,
    dateFilter: state.dateFilter,
    quickSearchTerm: state.quickSearchTerm,
    advancedFilters: state.advancedFilters,
    currencyFilter: state.currencyFilter,
    platformFilter: state.platformFilter,
  };
}

export function getSecondaryMarketTradeBlotterPreferenceState(
  state: SecondaryMarketTradeBlotterState,
): IBlotterPreferenceState {
  if (state.blotterPreferenceState && !state.blotterPreferenceState.pageSizeState) {
    state.blotterPreferenceState.pageSizeState = 25;
  }
  return state.blotterPreferenceState;
}

export function isSecondaryMarketTradeBlotterLoading(state: SecondaryMarketTradeBlotterState): boolean {
  return state.loading;
}

export function areBlotterPreferencesInError(state: AppState): boolean {
  return state.blotters.secondaryMarket.areBlotterPreferencesInError;
}

export function canSaveBlotterPreferences(state: AppState): boolean {
  return state.blotters.secondaryMarket.canSaveBlotterPreferences;
}

export function getSecondaryTradeBlotterItemByQuoteId(state: AppState, quoteId: string | undefined) {
  if (quoteId === undefined) {
    return undefined;
  }
  return state.blotters.secondaryMarket.items?.find(x => x.quoteId === quoteId);
}
